import HttpClient from "./interfaces/HttpClient";
import OverlayEvent from "../model/OverlayEvent";
import _environment from "../environments/SiteEnvironment";
import _logging_service from "./LoggingService";
import _http_client from "../clients/AxiosHttpClient";

const _target_server = _environment.targetServer;

export class EventsService {

    constructor(private httpClient: HttpClient) {}

    public async getNextOverlayEvent(lastEventIndex: number): Promise<OverlayEvent | undefined> {
        try {
            return await this.httpClient.get<OverlayEvent | undefined>(
                `${_target_server}v1/overlay/events/next/${lastEventIndex}`);
        } catch (e) {
            _logging_service.log(e);
            throw e;
        }
    }

    public async getCurrentEventCount(): Promise<number> {
        try {
            return await this.httpClient.get<number>(
                `${_target_server}v1/overlay/events/count`);
        } catch (e) {
            _logging_service.log(e);
            throw e;
        }
    }

    public async getAllEvents(): Promise<OverlayEvent[]> {
        try {
            return await this.httpClient.get<OverlayEvent[]>(
                `${_target_server}v1/overlay/events`);
        } catch (e) {
            _logging_service.log(e);
            throw e;
        }
    }
}

const _events_service = new EventsService(_http_client);

export default _events_service;